










import { Component, Mixins } from 'vue-property-decorator'
import AuthService from '@/services/auth-service'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class VerifyRegistraionView extends Mixins(
  AuthService,
  SnackbarService
) {
  token: any

  verificationError = false
  created() {
    const token = this.$route.params.token
    console.log('token', token)
    this.verifyRegistrationToken(token)
      .then((res: any) => {
        this.$router.push('/login')
        this.notify({
          text: `Welcom to Inventario Ganadero. The registration process is complete. You can now login.`,
          type: 'success',
          timeout: 20000,
        })
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          this.verificationError = true
        } else {
          this.notify({ text: `Error verifying registration email: ${error}` })
        }
      })
  }
}
